export enum SearchSelectTypes {
  Title = "title",
  Description = "description",
  Tag = "tag",
}

export const SEARCH_MAX_LENGTH = 200;
